'use strict';

exports.__esModule = true;
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
exports['default'] = transferProps;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _validators = require('react-decoration/lib/utils/validators');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function transferProps(Target) {
  (0, _validators.validateClass)(Target, 'transferProps');
  return function (props) {
    var others = {};
    var newProps = Object.assign({}, props);
    Object.keys(newProps).forEach(function (key) {
      if (!(Target.propTypes && Target.propTypes[key])) {
        others[key] = newProps[key];
        delete newProps[key];
      }
    });
    return _react2['default'].createElement(Target, _extends({
      others: others
    }, newProps));
  };
}